import { css } from '@emotion/core';
import styled from '@emotion/styled';

export const BaseIcon = styled('svg')(css`
  color: currentColor;
`);
